<template>
	<div class="title-chart-info">
		<SingleRankingDisplay
			class="title-chart-info__rank"
			v-if="streamingChartInfo.rank"
			:rank="streamingChartInfo.rank"
			:trend="streamingChartInfo.trend"
			:trendDifference="streamingChartInfo.trendDifference"
		/>
		<div class="title-chart-info__item">
			<p class="title-chart-info__item__title">{{ $t('WEBAPP_HIGHEST') }}:</p>
			<p class="title-chart-info__item__value">{{ topRankString }}</p>
		</div>
		<div class="title-chart-info__item">
			<p class="title-chart-info__item__title">{{ $t('WEBAPP_TOP10') }}:</p>
			<p class="title-chart-info__item__value">
				{{ $t('WEBAPP_X_DAYS', { number: streamingChartInfo.daysInTop10 }) }}
			</p>
		</div>
		<div class="title-chart-info__item">
			<p class="title-chart-info__item__title">{{ $t('WEBAPP_TOP100') }}:</p>
			<p class="title-chart-info__item__value">
				{{ $t('WEBAPP_X_DAYS', { number: streamingChartInfo.daysInTop100 }) }}
			</p>
		</div>
		<div class="title-chart-info__item">
			<p class="title-chart-info__item__title">{{ $t('WEBAPP_TOP1000') }}:</p>
			<p class="title-chart-info__item__value">
				{{ $t('WEBAPP_X_DAYS', { number: streamingChartInfo.daysInTop1000 }) }}
			</p>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { StreamingChartInfo } from '@/@types/graphql-types';
import { computed } from 'vue';
import SingleRankingDisplay from '@/components/streaming-charts/SingleRankingDisplay.vue';

const props = defineProps<{ streamingChartInfo: StreamingChartInfo }>();

const topRankString = computed(() => {
	return props.streamingChartInfo.topRank.toString().padStart(2, '0') + '.';
});
</script>

<style lang="scss" scoped>
.title-chart-info {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 24px;

	&__rank {
		margin-bottom: 8px;
	}

	&__item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 4px;

		&__title {
			margin: 0;
			color: #6f7d90;
			font-size: 16px;
			font-weight: 400;
			line-height: 24px;
			letter-spacing: 0.015em;
		}

		&__value {
			margin: 0;
			color: #c6c8cd;
			font-size: 16px;
			font-weight: 400;
			line-height: 24px;
			letter-spacing: 0em;
			text-transform: uppercase;
		}
	}
}
</style>
